import { Extension } from "@tiptap/core";

export const UnsetAllMarks = Extension.create({
  addKeyboardShortcuts() {
    return {
      "Mod-\\": (): boolean => this.editor.commands.unsetAllMarks(),
    };
  },
});
